import { putData, appointmentsBaseUrl } from "@Services/constServices";

export const convertReserveToCommand_service = async (reserveId: number) => {
  const url = `${appointmentsBaseUrl}/convert-to-comanda?reserveId=${reserveId}`;
  const successMessage = "Reserva actualizada correctamente";
  const errorMessage =
    "Hubo un problema al actualizar la reserva, intente nuevamente";
  return putData(url, {}, successMessage, errorMessage);
};
